import * as React from 'react'

import ItemsListing from '../../../components/itemsListing'
import createSearchResultBodyContainer, {
  Props
} from '../../../containers/searchResultBodyContainer'
import WithItemDecorator from '../../../containers/withItemDecorator'

const SearchResultBody: React.SFC<Props> = ({
  matches,
  currentSite,
  viewType,
  location,
  listName
}) => (
  <WithItemDecorator
    listName={listName}
    render={itemDecorator => (
      <ItemsListing
        items={matches}
        itemDecorator={itemDecorator}
        location={location}
        currentSite={currentSite}
        viewType={viewType}
      />
    )}
  />
)

export default createSearchResultBodyContainer(SearchResultBody)
